import React from 'react';
import apiClient, { getAccessToken } from '../../apiClient';
import { withRouter } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import MaterialTable from '../../Components/DataTable/DataTable';
import { CSVLink } from 'react-csv';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Button, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import './Commission.scss';

const COMMISSION_TYPES = ['Rate', 'Percentage', 'Individual'];

const getCommissionTypeDisplayLabel = (type) => {
  const t = String(type || '').trim();
  if (t === 'Amount' || t === 'Individual') return 'Individual Commission';
  return t;
};

const normalizeCommissionTypeValue = (type) => {
  const t = String(type || '').trim();
  if (t === 'Amount') return 'Individual';
  return t;
};

const emptyRow = (id) => ({
  id,
  name: '',
  type: 'Percentage',
  percentage: '',
  rate: '',
  amount: '',
});

const isFieldEnabled = (type, field) => {
  const normalized = normalizeCommissionTypeValue(type);
  if (field === 'rate') return normalized === 'Rate';
  if (field === 'percentage') return normalized === 'Percentage';
  if (field === 'amount') return normalized === 'Individual';
  return false;
};

const validateCommissionRow = (row) => {
  const name = (row.name || '').trim();
  const type = normalizeCommissionTypeValue((row.type || '').trim());
  if (!name) return 'Name is required.';
  if (!type || !COMMISSION_TYPES.includes(type)) return 'Type is required.';
  if (type === 'Rate' && (row.rate === '' || row.rate == null)) return 'Rate is required when Type is Rate.';
  if (type === 'Percentage' && (row.percentage === '' || row.percentage == null)) {
    return 'Percentage is required when Type is Percentage.';
  }
  if (type === 'Individual' && (row.amount === '' || row.amount == null)) {
    return 'Individual amount is required when Type is Individual Commission.';
  }
  return null;
};

class Commission extends React.Component {
  state = {
    Results: [],
    showEdit: false,
    currentCommissionId: 0,
    currentName: '',
    currentType: 'Percentage',
    currentPercentage: '',
    currentRate: '',
    currentAmount: '',
    fullWidth: true,
    maxEditWidth: 'md',
    columns: [
      {
        title: '',
        field: 'CommissionId',
        render: (rowData) => (
          <a href="javascript:void(0)" onClick={() => this.handleLinkEditClick(rowData)}>
            Edit
          </a>
        ),
      },
      { title: 'Name', field: 'Name' },
      { title: 'Type', field: 'Type', render: (rowData) => getCommissionTypeDisplayLabel(rowData.Type) },
      { title: 'Percentage %', field: 'Percentage' },
      { title: 'Rate', field: 'Rate' },
      { title: 'Individual amount', field: 'Amount' },
    ],
    headers: [
      { label: 'Name', key: 'Name' },
      { label: 'Type', key: 'Type' },
      { label: 'Percentage %', key: 'Percentage' },
      { label: 'Rate', key: 'Rate' },
      { label: 'Individual amount', key: 'Amount' },
    ],
    submitted: false,
    successMessage: null,
    errorMessage: null,
    rows: [],
    showConfirm: false,
    rowIndex: 0,
  };

  componentDidMount() {
    sessionStorage.setItem('TranSearch', null);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const accessToken = getAccessToken();

    apiClient
      .get('/api/get/commission', { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => this.setState({ Results: res.data || [] }));

    if (
      user.permissions.filter((x) => x.PermissionName === 'Payment Method' && x.PermissionAllowed === 1)
        .length === 0
    ) {
      const { history } = this.props;
      history.push('/home');
    }
  }

  reloadPage = () => {
    const { history } = this.props;
    history.push('/vendor-details');
    setTimeout(() => {
      history.push('/commission');
    }, 1);
  };

  setShowEdit = (state) => this.setState({ showEdit: state });

  handleLinkEditClick = (item) => {
    this.setShowEdit(true);
    this.setState({
      currentCommissionId: item.CommissionId,
      currentName: item.Name || '',
      currentType: normalizeCommissionTypeValue(item.Type || 'Percentage'),
      currentPercentage: item.Percentage != null ? item.Percentage : '',
      currentRate: item.Rate != null ? item.Rate : '',
      currentAmount: item.Amount != null ? item.Amount : '',
    });
  };

  handleEditSave = () => {
    const row = {
      name: this.state.currentName,
      type: this.state.currentType,
      percentage: this.state.currentPercentage,
      rate: this.state.currentRate,
      amount: this.state.currentAmount,
    };
    const error = validateCommissionRow(row);
    if (error) {
      this.setState({ errorMessage: error });
      setTimeout(() => this.setState({ errorMessage: null }), 8000);
      return;
    }

    const user = JSON.parse(sessionStorage.getItem('user'));
    const accessToken = user.accessToken;
    apiClient
      .post(
        '/api/post/commissionUpdate',
        {
          name: row.name.trim(),
          type: row.type,
          percentage: row.percentage,
          rate: row.rate,
          amount: row.amount,
          commissionId: this.state.currentCommissionId,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      .then(() => {
        this.setState({ successMessage: 'Successfully saved!' });
        setTimeout(() => {
          this.setState({ successMessage: null });
          this.reloadPage();
        }, 3000);
        this.setShowEdit(false);
      })
      .catch((error) => {
        const message =
          error && error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : 'Unable to save commission.';
        this.setState({ errorMessage: message, successMessage: null });
        setTimeout(() => this.setState({ errorMessage: null }), 8000);
      });
  };

  handleSubmit = () => {
    if (!this.state.rows.length) {
      this.setState({ errorMessage: 'Add at least one commission row before submitting.' });
      setTimeout(() => this.setState({ errorMessage: null }), 8000);
      return;
    }

    const lastRow = this.state.rows[this.state.rows.length - 1];
    const error = validateCommissionRow(lastRow);
    if (error) {
      this.setState({ errorMessage: error });
      setTimeout(() => this.setState({ errorMessage: null }), 8000);
      return;
    }

    const user = JSON.parse(sessionStorage.getItem('user'));
    const accessToken = user.accessToken;
    apiClient
      .post('/api/post/commissions', this.state.rows, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then(() => {
        this.setState({ successMessage: 'Successfully saved!' });
        setTimeout(() => {
          this.setState({ successMessage: null });
          this.reloadPage();
        }, 3000);
      });
  };

  handleNo = () => this.setState({ showConfirm: false });
  handleConfirm = (index) => this.setState({ showConfirm: true, rowIndex: index });
  handleRemoveClick = () => {
    const list = [...this.state.rows];
    this.setState({
      rows: list.filter((x) => x.id !== this.state.rowIndex),
      showConfirm: false,
    });
  };

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.rows];
    list[index][name] = value;
    this.setState({ rows: list });
  };

  handleTypeChange = (e, index) => {
    const type = e.target.value;
    const list = [...this.state.rows];
    list[index].type = type;
    if (type !== 'Rate') list[index].rate = '';
    if (type !== 'Percentage') list[index].percentage = '';
    if (type !== 'Individual') list[index].amount = '';
    this.setState({ rows: list });
  };

  handleEditTypeChange = (e) => {
    const type = e.target.value;
    this.setState({
      currentType: type,
      currentRate: type === 'Rate' ? this.state.currentRate : '',
      currentPercentage: type === 'Percentage' ? this.state.currentPercentage : '',
      currentAmount: type === 'Individual' ? this.state.currentAmount : '',
    });
  };

  handleAdd = () => {
    if (this.state.rows.length > 0) {
      const error = validateCommissionRow(this.state.rows[this.state.rows.length - 1]);
      if (error) {
        this.setState({ errorMessage: `In last row added: ${error}` });
        setTimeout(() => this.setState({ errorMessage: null }), 8000);
        return;
      }
    }
    this.setState({
      rows: [...this.state.rows, emptyRow(this.state.rows.length + 1)],
    });
  };

  renderValueInput = (row, index, field, editState = null) => {
    const type = editState ? editState.type : row.type;
    const enabled = isFieldEnabled(type, field);
    const valueKey =
      field === 'rate' ? 'rate' : field === 'percentage' ? 'percentage' : 'amount';
    const value = editState ? editState[valueKey] : row[valueKey];
    const onChange = editState
      ? (e) => {
          if (field === 'rate') this.setState({ currentRate: e.target.value });
          else if (field === 'percentage') this.setState({ currentPercentage: e.target.value });
          else this.setState({ currentAmount: e.target.value });
        }
      : (e) => this.handleInputChange(e, index);

    return (
      <input
        type="number"
        value={value}
        name={valueKey}
        disabled={!enabled}
        onChange={onChange}
        style={{ opacity: enabled ? 1 : 0.5 }}
      />
    );
  };

  render() {
    const editState = {
      type: this.state.currentType,
      rate: this.state.currentRate,
      percentage: this.state.currentPercentage,
      amount: this.state.currentAmount,
    };

    return (
      <div className="ItemCategory">
        <h2>Commission</h2>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
          <div className="alignDiv">
            <Button onClick={this.handleAdd}>
              <AddBoxIcon />
              ADD
            </Button>
          </div>
        </div>

        <div style={{ marginTop: '10px' }}>
          <Table size="small" aria-label="commission entry table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Name</TableCell>
                <TableCell align="center">Type</TableCell>
                <TableCell align="center">Percentage %</TableCell>
                <TableCell align="center">Rate</TableCell>
                <TableCell align="center">Individual amount</TableCell>
                <TableCell align="center" />
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.rows.map((row, i) => (
                <TableRow key={`commission-row-${row.id}`}>
                  <TableCell padding="none" style={{ textAlign: 'left' }}>
                    <input
                      type="text"
                      value={row.name}
                      name="name"
                      onChange={(e) => this.handleInputChange(e, i)}
                    />
                  </TableCell>
                  <TableCell padding="none" style={{ textAlign: 'left' }}>
                    <select value={row.type} onChange={(e) => this.handleTypeChange(e, i)}>
                      {COMMISSION_TYPES.map((t) => (
                        <option key={t} value={t}>
                          {getCommissionTypeDisplayLabel(t)}
                        </option>
                      ))}
                    </select>
                  </TableCell>
                  <TableCell padding="none" style={{ textAlign: 'left' }}>
                    {this.renderValueInput(row, i, 'percentage')}
                  </TableCell>
                  <TableCell padding="none" style={{ textAlign: 'left' }}>
                    {this.renderValueInput(row, i, 'rate')}
                  </TableCell>
                  <TableCell padding="none" style={{ textAlign: 'left' }}>
                    {this.renderValueInput(row, i, 'amount')}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    <Button className="mr10" onClick={() => this.handleConfirm(row.id)}>
                      <DeleteOutlineIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <br />
          <br />
          <br />
          <Button color="primary" variant="contained" onClick={this.handleSubmit} disabled={this.state.submitted}>
            {this.state.submitted ? 'Your form is submitted!' : 'Submit'}
          </Button>

          {this.state.successMessage && (
            <div style={{ backgroundColor: '#28a745', color: '#fff', padding: '10px', marginTop: '10px' }}>
              {this.state.successMessage}
            </div>
          )}
          {this.state.errorMessage && (
            <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
              {this.state.errorMessage}
            </div>
          )}
        </div>

        <div style={{ maxWidth: '100%', paddingTop: '50px' }}>
          <div style={{ textAlign: 'right', paddingBottom: '3px' }}>
            <CSVLink data={this.state.Results} headers={this.state.headers}>
              Export to Excel
            </CSVLink>
          </div>
          <MaterialTable columns={this.state.columns} data={this.state.Results} title="Commissions" />
        </div>

        {this.state.showConfirm && (
          <Dialog open={this.state.showConfirm} onClose={this.handleNo}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
              <DialogContentText>Are you sure to delete</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.handleRemoveClick()} color="primary" autoFocus>
                Yes
              </Button>
              <Button onClick={this.handleNo} color="primary" autoFocus>
                No
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {this.state.showEdit && (
          <Dialog
            fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxEditWidth}
            open={this.state.showEdit}
            onClose={() => this.setShowEdit(false)}
          >
            <DialogTitle>
              <div style={{ float: 'left' }}>
                <h4>Edit Commission</h4>
              </div>
              <div style={{ float: 'right' }}>
                <IconButton aria-label="close" onClick={() => this.setShowEdit(false)}>
                  <CloseIcon />
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <div className="row mt-5">
                  <div className="row mt-5">
                    <div className="col-md-5" style={{ float: 'left', marginRight: '50px' }}>
                      <label>Name</label>
                    </div>
                    <div className="col-md-7">
                      <input
                        style={{ width: '250px' }}
                        type="text"
                        value={this.state.currentName}
                        onChange={(e) => this.setState({ currentName: e.target.value })}
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row mt-5">
                    <div className="col-md-5" style={{ float: 'left', marginRight: '50px' }}>
                      <label>Type</label>
                    </div>
                    <div className="col-md-7">
                      <select
                        style={{ width: '250px' }}
                        value={this.state.currentType}
                        onChange={this.handleEditTypeChange}
                      >
                        {COMMISSION_TYPES.map((t) => (
                          <option key={t} value={t}>
                            {getCommissionTypeDisplayLabel(t)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <br />
                  <div className="row mt-5">
                    <div className="col-md-5" style={{ float: 'left', marginRight: '50px' }}>
                      <label>Percentage %</label>
                    </div>
                    <div className="col-md-7">{this.renderValueInput(null, null, 'percentage', editState)}</div>
                  </div>
                  <br />
                  <div className="row mt-5">
                    <div className="col-md-5" style={{ float: 'left', marginRight: '50px' }}>
                      <label>Rate</label>
                    </div>
                    <div className="col-md-7">{this.renderValueInput(null, null, 'rate', editState)}</div>
                  </div>
                  <br />
                  <div className="row mt-5">
                    <div className="col-md-5" style={{ float: 'left', marginRight: '50px' }}>
                      <label>Individual amount</label>
                    </div>
                    <div className="col-md-7">{this.renderValueInput(null, null, 'amount', editState)}</div>
                  </div>
                  <br />
                  <div className="row mt-5" style={{ textAlign: 'center' }}>
                    <div className="col-md-6 mr-1" style={{ textAlign: 'center', float: 'left', marginRight: '2px' }}>
                      <Button className="mr10" color="primary" variant="contained" onClick={this.handleEditSave}>
                        Save
                      </Button>
                    </div>
                    <div className="col-md-6" style={{ textAlign: 'center', float: 'left' }}>
                      <Button className="mr10" color="primary" variant="contained" onClick={() => this.setShowEdit(false)}>
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions />
          </Dialog>
        )}
      </div>
    );
  }
}

export default withRouter(Commission);
